import React, { useEffect, useState } from "react";
import PageTitle from "../layouts/PageTitle";
import AddEvent from "../modal/AddEvent";
import PhoneInput from "react-phone-input-2";

import "react-phone-input-2/lib/bootstrap.css";
import { addVendorDetails } from "../components/APIs/Api";
import { connect } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import Lottie from "lottie-react";
import animationData from "..//../images/loding.json";
import GoogleComponent from "react-google-autocomplete";
import GooglePlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
  geocodeByPlaceId,
} from "react-google-places-autocomplete";
import AWS from "aws-sdk";

const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];
function AddVenderDetails(props) {
  const s3 = new AWS.S3();
  const [selectImage, setSelectImage] = useState();
  const userId = localStorage.getItem("VendorId");

  const [happyHoursImage, setHappyHoursImage] = useState(null);

  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };

  const [loader, setLoader] = useState(false);
  const [location, setLocation] = useState({
    address: "",
    lat: 0,
    long: 0,
    zipCode: "",
    city: "",
  });
  let zipCode = "";
  let city = "";
  let errorsObj = {
    businessName: "",
    address: "",
    typeOfBusiness: "",
    city: "",
    zipCode: "",
    PhoneNumber: "",
    startTime: "",
    endTime: "",
    day: "",
    happyStartTime: "",
    happyEndTime: "",
    deal: [],
  };
  const [errors, setErrors] = useState(errorsObj);
  const [eventModal, setEventModal] = useState(false);
  const [numberError, setNumberError] = useState("");
  const [phone, setPhone] = useState("");
  const [show, setShow] = useState(0);
  const [applyToAllDay, setApplyToAllDay] = useState(false);
  const [priceData, setPriceData] = useState([]);

  ///==================opratingHour FormData=============
  const initialData = {
    startTime: "",
    endTime: "",
    status: true,
  };

  const [selectedDay, setSelectedDay] = useState(0);
  const [opratingHour, setOpratingHour] = useState(
    daysOfWeek.map((day) => ({
      day,
      ...initialData,
    }))
  );

  //============convert Time in 12hr=============================
  const convertTo12HourFormat = (time24hr) => {
    const [hour, minute] = time24hr.split(":");
    const amPm = parseInt(hour, 10) >= 12 ? "PM" : "AM";
    const hour12 = parseInt(hour, 10) % 12 || 12;
    return `${hour12}:${minute} ${amPm}`;
  };
  //=================convert time in 24hr=================
  const convertTo24HourFormat = (time12hr) => {
    if (!time12hr) {
      return "";
    }

    const parts = time12hr.split(" ");

    if (parts.length !== 2) {
      return "";
    }

    const [time, period] = parts;
    const [hour, minute] = time.split(":");

    if (hour === undefined || minute === undefined) {
      return ""; // Handle invalid time format
    }

    let hour24 = parseInt(hour, 10);
    if (period === "PM" && hour24 !== 12) {
      hour24 += 12;
    } else if (period === "AM" && hour24 === 12) {
      hour24 = 0;
    }

    return `${hour24.toString().padStart(2, "0")}:${minute}`;
  };

  //====================onChange function in Opreting hr================
  const handleOpratingInputChange = (e, dayIndex, key) => {
    let { value } = e.target;

    if (key === "startTime" || key === "endTime") {
      value = convertTo12HourFormat(value);
    }

    const updatedFormData = [...opratingHour];
    updatedFormData[dayIndex][key] = value;
    setOpratingHour(updatedFormData);
  };

  //======================Apply to all function =====================
  const applyToAll = () => {
    const selectedData = {
      startTime: opratingHour[selectedDay]?.startTime,
      endTime: opratingHour[selectedDay]?.endTime,
      status: opratingHour[selectedDay]?.status,
    };

    const updatedFormData = opratingHour.map((data) => ({
      ...data,
      ...selectedData,
    }));
    setOpratingHour(updatedFormData);
  };

  const toggleDayForm = (dayIndex) => {
    setSelectedDay(dayIndex);
  };

  //==============oprating day open and close ========================
  const handleOpratingcheck = (event, dayIndex, key) => {
    const updatedInfo = [...opratingHour];
    updatedInfo[dayIndex][key] = event.target.checked;
    setOpratingHour(updatedInfo);
  };

  //=============formData=============
  const [formData, setFormData] = useState({
    PhoneNumber: "",
    typeOfBusiness: "",
    businessName: "",
  });

  // ===========================TEsting==================================================

  const happyInitialData = {
    image: {},
    startTime: "",
    endTime: "",
    deals: [
      {
        deal: "",
        price: "",
        type: "",
        other: false,
      },
    ],
  };

  const [happyHourInfo, setHappyHourInfo] = useState(
    daysOfWeek.map((day) => ({
      day,
      ...happyInitialData,
    }))
  );

  const handleDealInputChange = (event, dayIndex, dealIndex, key) => {
    const updatedInfo = JSON.parse(JSON.stringify(happyHourInfo));

    updatedInfo[dayIndex].deals[dealIndex][key] = event.target.value;

    if (event.target.value === "other") {
      updatedInfo[dayIndex].deals[dealIndex]["other"] = true;
      updatedInfo[dayIndex].deals[dealIndex][key] = "";
    } else {
      updatedInfo[dayIndex].deals[dealIndex]["other"] = false;
    }
    setHappyHourInfo(updatedInfo);
  };

  //////////=========venderLocation==============

  const handleAddress = (place) => {
    setLocation({ address: place?.label });

    geocodeByAddress(place.label)
      .then((results) => {
        const addressComponents = results[0]?.address_components || [];
        city =
          addressComponents.find(
            (component) =>
              component.types.includes("locality") ||
              component.types.includes("administrative_area_level_2")
          )?.long_name || "";

        // Find the zip code from address components
        zipCode =
          addressComponents.find((component) =>
            component.types.includes("postal_code")
          )?.long_name || "";

        return getLatLng(results[0]);
      })
      .then((res) => {
        setLocation((prevLocation) => ({
          ...prevLocation,
          lat: res.lat,
          long: res.lng,
          zipCode: zipCode,
          city: city,
        }));
      })
      .catch((error) => {
        console.error("Error getting address details:", error);
      });
  };

  const handleHappyHoursImage = async (event, index, key) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      const s3Data = await handleUploadImage(file);
      setHappyHoursImage(s3Data);
      const updatedInfo = [...happyHourInfo];
      updatedInfo[index][key] = s3Data.Key || s3Data.Location;
      setHappyHourInfo(updatedInfo);
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  const handleInputChange = (event, index, key) => {
    const updatedInfo = [...happyHourInfo];

    let { name, value } = event.target;

    if (key === "startTime" || key === "endTime") {
      value = convertTo12HourFormat(value);
    }
    updatedInfo[index][key] = value;
    setHappyHourInfo(updatedInfo);
  };
  // Function to add a deal to a specific happy hour entry
  const addDeal = (index) => {
    // const updatedInfo = [...happyHourInfo];
    const updatedInfo = JSON.parse(JSON.stringify(happyHourInfo));
    updatedInfo[index].deals.push({ deal: "", price: "", type: "" });
    setHappyHourInfo(updatedInfo);
  };

  function handleTextInputChange(event, index, dealIndex) {
    if (!Array.isArray(happyHourInfo)) {
      return;
    }

    const updatedInfo = [...happyHourInfo];
    if (
      updatedInfo[index] &&
      updatedInfo[index].deals &&
      Array.isArray(updatedInfo[index].deals)
    ) {
      updatedInfo[index].deals[dealIndex]["deal"] = event.target.value;
      setHappyHourInfo(updatedInfo);
    } else {
      console.error("Invalid structure of happyHourInfo at index", index);
    }
  }

  const deleteDeal = (index, dealIndex) => {
    if (happyHourInfo[index].deals.length > 1) {
      const updatedItems = [...happyHourInfo];
      updatedItems[index].deals.splice(dealIndex, 1);
      setHappyHourInfo(updatedItems);
    }
  };

  const applyToAllHappyHour = () => {
    const dayNames = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];

    let hasError = false;

    // Validate the selected day's data
    const selectedData = happyHourInfo[selectedDay];
    if (!selectedData) {
      toast.error("Please select a day before applying to all.");
      return;
    }

    if (!selectedData.startTime || !selectedData.endTime) {
      toast.error("Start Time and End Time are required.");
      hasError = true;
    }

    selectedData.deals.forEach((deal, index) => {
      if (!deal.deal || !deal.price || !deal.type) {
        toast.error(
          `Deal ${index + 1}: All fields (Deal, Price, and Type) are required.`
        );
        hasError = true;
      }
    });

    if (hasError) {
      return; // Stop applying if validation fails
    }

    const updatedFormData = happyHourInfo.map((dayData, dayIndex) => {
      if (dayIndex === selectedDay) return dayData;

      return {
        ...dayData,
        day: dayNames[dayIndex],
        startTime: selectedData.startTime,
        endTime: selectedData.endTime,
        image: selectedData.image,

        deals: selectedData.deals.map((deal) => ({
          ...deal,
          id: deal.id || `${dayIndex}-${Math.random()}`, // Ensure unique ID for each day
        })),
      };
    });

    setHappyHourInfo(updatedFormData);
    toast.success("Applied to all days successfully.");
  };

  function hendleOnNext() {
    let error = false;
    const errorObj = { ...errorsObj };
    if (formData.businessName === "") {
      errorObj.businessName = "This field is required";
      error = true;
    }
    if (formData.number === "") {
      errorObj.number = "This field is required";
      error = true;
    }
    if (formData.typeOfBusiness === "") {
      errorObj.typeOfBusiness = "This field is required";
      error = true;
    }
    if (formData.city === "") {
      errorObj.city = "This field is required";
      error = true;
    }
    if (formData.zipCode === "") {
      errorObj.zipCode = "This field is required";
      error = true;
    }
    if (formData.PhoneNumber === "") {
      errorObj.PhoneNumber = "This field is required";
      error = true;
    }
    if (formData.PhoneNumber.length < 6) {
      errorObj.PhoneNumber = "Number will be greater than 6";
      error = true;
    }
    if (formData.PhoneNumber.length > 15) {
      errorObj.PhoneNumber = "Number will be less than 15";
      error = true;
    }
    if (formData.startTime === "") {
      errorObj.startTime = "This field is required";
      error = true;
    }
    if (formData.endTime === "") {
      errorObj.endTime = "This field is required";
      error = true;
    }

    const isAnyOpratingHourFormFilled = opratingHour.some(
      (item) => item.startTime || item.endTime
    );

    if (!isAnyOpratingHourFormFilled) {
      errorObj.startTime = "This field is required";
      errorObj.endTime = "This field is required";
      error = true;
    }

    setErrors(errorObj);
    if (error) {
      return;
    } else {
      setShow(1);
      scrollToTop();
    }
  }

  const handleUploadImage = async (file) => {
    if (!file) {
      console.error("No file selected");
      return;
    }

    const params = {
      Bucket: process.env.REACT_APP_BUCKET_NAME,
      Key: file.name,
      Body: file,
    };

    try {
      const data = await s3.upload(params).promise();
      return data;
    } catch (error) {
      console.error("Upload failed:", error);
      throw error;
    }
  };

  useEffect(() => {
    const handleUpload = async () => {
      if (!happyHourInfo || happyHourInfo.length === 0) {
        console.error("No happy hour info provided");
        return;
      }

      const uploadPromises = happyHourInfo?.map(async (item, i) => {
        const file = new File([item?.image], new Date().getTime());
        try {
          return {
            image: happyHoursImage?.key,
            day: item?.day,
            startTime: item?.startTime,
            endTime: item?.endTime,
            deals:
              item?.deals?.map((dealItem) => ({
                deal: dealItem?.deal,
                price: dealItem?.price ? dealItem?.price : dealItem?.type,
                type: dealItem?.type,
              })) || [],
          };
        } catch (error) {
          console.error("Upload failed:", error);
          return null;
        }
      });

      try {
        const uploadedImages = await Promise.all(uploadPromises);
        setSelectImage(uploadedImages);
      } catch (error) {
        console.error("Error uploading images:", error);
      }
    };

    handleUpload();
  }, [happyHourInfo]);

  //==============ApiCall============
  async function onSubmit(e) {
    e.preventDefault();
    setLoader(true);

    // const filteredOpratingHours = opratingHour.filter(
    //   (item) => item.startTime || item.endTime
    // );
    const filteredOpratingHours = opratingHour
      .filter((item) => item.startTime || item.endTime)
      .map((item) => ({
        ...item,
        status: !item.status,
      }));

    const filteredHappyHourInfo = selectImage.filter((item) => {
      // Check if startTime or endTime is non-empty
      const hasValidTime =
        (item.startTime && item.startTime.trim() !== "") ||
        (item.endTime && item.endTime.trim() !== "");

      // Check if there is at least one non-empty deal
      const hasValidDeal =
        item.deals &&
        item.deals.some(
          (deal) =>
            deal.deal.trim() !== "" ||
            deal.price.trim() !== "" ||
            deal.type.trim() !== ""
        );

      // Keep the item only if it has valid time or valid deals
      return hasValidTime || hasValidDeal;
    });

    const res = await addVendorDetails(
      formData,
      filteredOpratingHours,
      userId,
      location,
      phone,
      filteredHappyHourInfo
    )
      .then((response) => {
        if (response?.status === 200) {
          toast.success("Add Successful", {
            position: toast.POSITION.TOP_RIGHT,
          });
          setLoader(false);
          setEventModal(true);
        }
      })
      .catch((error) => {
        toast.error(`❌${error?.response?.data?.data}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
        setLoader(false);
      });
  }

  return (
    <div>
      <ToastContainer
        position="top-right"
        autoClose={8000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <PageTitle activeMenu=" Add Vendor Details" motherMenu="Vendor" />
      <div className="col-lg-12">
        {loader ? (
          <div className="">
            <Lottie
              style={{ height: "200px", marginTop: "45px", padding: "30px" }}
              animationData={animationData}
            />
          </div>
        ) : (
          <div className="authincation-content text-black p-5">
            <div className="mb-4">
              <h3 className="mb-1 font-w600 text-black ">Vendor Details</h3>
            </div>
            <form onSubmit={onSubmit}>
              {show === 0 ? (
                <div>
                  <div className="form-group">
                    <label className="text-black font-w500">
                      Business Type
                    </label>
                    <div className="contact-name">
                      <select
                        className="form-control"
                        name="typeOfBusiness"
                        value={formData.typeOfBusiness}
                        onChange={(event) =>
                          setFormData({
                            ...formData,
                            typeOfBusiness: event.target.value,
                          })
                        }
                        required
                      >
                        <option hidden>Select..</option>
                        <option value="Bar">Bar</option>
                        <option value="Club">Club</option>
                        <option value="Comedy Club">Comedy Club</option>
                        <option value="Restaurant">Restaurant</option>
                        <option value="Brewery">Brewery</option>
                        <option value="Festival">Festival</option>
                        <option value="Speakeasy">Speakeasy</option>
                        <option value="Sports Bar">Sports Bar</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>

                    {errors.typeOfBusiness && (
                      <div className="text-danger fs-12">
                        {errors.typeOfBusiness}
                      </div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="mb-2 ">Name of Business</label>
                    <input
                      type="text"
                      className="form-control"
                      name="businessName"
                      value={formData.businessName}
                      onChange={(event) =>
                        setFormData({
                          ...formData,
                          businessName: event.target.value,
                        })
                      }
                      placeholder="Enter Name of Business"
                    />
                    {errors.businessName && (
                      <div className="text-danger fs-12">
                        {errors.businessName}
                      </div>
                    )}
                  </div>
                  <div className="form-group auto-address">
                    <label className="mb-2 ">Address</label>
                    <GooglePlacesAutocomplete
                      className="form-control"
                      apiKey={process.env.REACT_APP_GOOGLE_API_KEY}
                      selectProps={{
                        placeholder: "Enter Address",
                        // name: "address",
                        onChange: (place) => {
                          handleAddress(place);
                        },
                      }}
                    />
                    {errors.address && (
                      <div className="text-danger fs-12">{errors.address}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="mb-2 ">City</label>
                    <input
                      type="text"
                      className="form-control"
                      name="city"
                      value={location.city}
                      onChange={(event) =>
                        setLocation({ ...location, city: event.target.value })
                      }
                      placeholder="Enter City"
                    />
                    {errors.city && (
                      <div className="text-danger fs-12">{errors.city}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="mb-2 ">Zip Code</label>
                    <input
                      type="text"
                      className="form-control"
                      name="zipCode"
                      value={location.zipCode}
                      onChange={(event) =>
                        setLocation({
                          ...location,
                          zipCode: event.target.value,
                        })
                      }
                      placeholder="Enter Zip Code"
                    />
                    {errors.zipCode && (
                      <div className="text-danger fs-12">{errors.zipCode}</div>
                    )}
                  </div>
                  <div className="form-group">
                    <label className="mb-2 ">Phone Number</label>

                    <div className="contact-name d-flex">
                      <PhoneInput
                        className="p-0 conuntry-code"
                        country={"us"}
                        enableSearch={true}
                        value={phone}
                        onChange={(phone) => setPhone(`+${phone}`)}
                      />
                      <input
                        type="number"
                        className="form-control"
                        value={formData.PhoneNumber}
                        onChange={(event) =>
                          setFormData({
                            ...formData,
                            PhoneNumber: event.target.value,
                          })
                        }
                        placeholder="Enter Phone Number"
                      />
                    </div>
                    {errors.PhoneNumber && (
                      <div className="text-danger fs-12">
                        {errors.PhoneNumber}
                      </div>
                    )}
                  </div>

                  <div className="form-group ">
                    <h4 className="mb-5 mt-3">Operating Hours</h4>
                    <div className="d-flex justify-content-end mb-3">
                      <button
                        type="button"
                        className="btn fs-12 py-2 px-3 applyBtn"
                        onClick={applyToAll}
                      >
                        Apply to All
                      </button>
                    </div>
                    <label className="mb-2 mt-2">Day(s)</label>
                    <div
                      className="d-flex align-items-center mb-2"
                      style={{ gap: "10px" }}
                    >
                      {daysOfWeek.map((day, dayIndex) => (
                        <div key={dayIndex}>
                          <p
                            className={dayIndex === selectedDay ? "days" : " "}
                            onClick={() => toggleDayForm(dayIndex)}
                            style={{ cursor: "pointer" }}
                          >
                            {day}
                          </p>
                        </div>
                      ))}
                    </div>
                    {daysOfWeek.map((day, dayIndex) => (
                      <div key={dayIndex}>
                        {selectedDay === dayIndex && (
                          <div>
                            <div className="form-group d-flex mt-2">
                              <div className="w-100 mr-2">
                                <label className="mb-2 ">Start Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="startTime"
                                  defaultValue={convertTo24HourFormat(
                                    opratingHour[dayIndex]?.startTime
                                  )}
                                  onChange={(e) =>
                                    handleOpratingInputChange(
                                      e,
                                      dayIndex,
                                      "startTime"
                                    )
                                  }
                                  disabled={opratingHour[dayIndex]?.status}
                                />

                                {errors.startTime && (
                                  <div className="text-danger fs-12">
                                    {errors.startTime}
                                  </div>
                                )}
                              </div>
                              <div className="w-100">
                                <label className="mb-2 ">End Time</label>
                                <input
                                  type="time"
                                  className="form-control"
                                  name="endTime"
                                  defaultValue={convertTo24HourFormat(
                                    opratingHour[dayIndex]?.endTime
                                  )}
                                  onChange={(e) =>
                                    handleOpratingInputChange(
                                      e,
                                      dayIndex,
                                      "endTime"
                                    )
                                  }
                                  disabled={opratingHour[dayIndex]?.status}
                                />
                                {errors.endTime && (
                                  <div className="text-danger fs-12">
                                    {errors.endTime}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div
                              className="d-flex align-items-center m-0"
                              style={{ gap: "6px" }}
                            >
                              <input
                                id="status"
                                className="mb-4"
                                type="checkbox"
                                checked={opratingHour[dayIndex]?.status}
                                onChange={(e) =>
                                  handleOpratingcheck(e, dayIndex, "status")
                                }
                              />
                              <label
                                className="m-0 mb-3 cursor-pointer"
                                htmlFor="status"
                              >
                                Closed
                              </label>
                            </div>
                          </div>
                        )}
                      </div>
                    ))}
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-sm"
                        style={{
                          backgroundColor: "#F36C03",
                          border: "none",
                          color: "white",
                        }}
                        onClick={() => hendleOnNext()}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="d-flex justify-content-start">
                    <button
                      className="btn btn-sm"
                      style={{
                        backgroundColor: "#F36C03",
                        border: "none",
                        color: "white",
                      }}
                      onClick={() => setShow(0)}
                    >
                      Prev
                    </button>
                  </div>
                  <h4 className="my-4 text-black">Happy Hour Info </h4>
                  <div className="d-flex justify-content-end mb-3">
                    <button
                      type="button"
                      className="btn fs-12 py-2 px-3 applyBtn"
                      onClick={applyToAllHappyHour}
                    >
                      Apply to All
                    </button>
                  </div>
                  <label className="mb-2 mt-2">Day(s)</label>
                  <div
                    className="d-flex align-items-center mb-2"
                    style={{ gap: "10px" }}
                  >
                    {daysOfWeek.map((day, dayIndex) => (
                      <div key={dayIndex}>
                        <p
                          className={dayIndex === selectedDay ? "days" : " "}
                          onClick={() => toggleDayForm(dayIndex)}
                          style={{ cursor: "pointer" }}
                        >
                          {day}
                        </p>
                      </div>
                    ))}
                  </div>
                  {daysOfWeek.map((day, dayIndex) => (
                    <div key={dayIndex}>
                      {selectedDay === dayIndex && (
                        <div>
                          <div className="form-group">
                            <label className="mb-2 ">Image</label>
                            <input
                              type="file"
                              accept=".jpg, .jpeg, .png"
                              className="form-control"
                              multiple
                              onChange={(e) =>
                                handleHappyHoursImage(e, dayIndex, "image")
                              }
                            />
                            <div>
                              <p className="ml-1 text-warning">
                                Upload file:{" "}
                                {happyHourInfo[dayIndex]?.image?.name}
                              </p>
                            </div>
                          </div>
                          <div className="form-group d-flex">
                            <div className="w-100 mr-2">
                              <label className="mb-2 ">Start Time</label>
                              <input
                                type="time"
                                className="form-control"
                                defaultValue={convertTo24HourFormat(
                                  happyHourInfo[dayIndex]?.startTime
                                )}
                                onChange={(e) =>
                                  handleInputChange(e, dayIndex, "startTime")
                                }
                              />
                              {errors.happyStartTime && (
                                <div className="text-danger fs-12">
                                  {errors.happyStartTime}
                                </div>
                              )}
                            </div>
                            <div className="w-100">
                              <label className="mb-2 ">End Time</label>
                              <input
                                type="time"
                                className="form-control"
                                defaultValue={convertTo24HourFormat(
                                  happyHourInfo[dayIndex]?.endTime
                                )}
                                onChange={(e) =>
                                  handleInputChange(e, dayIndex, "endTime")
                                }
                              />
                              {errors.happyEndTime && (
                                <div className="text-danger fs-12">
                                  {errors.happyEndTime}
                                </div>
                              )}
                            </div>
                          </div>
                          {happyHourInfo[dayIndex]?.deals?.map(
                            (deal, dealIndex) => (
                              <div
                                className="form-group d-flex"
                                key={dealIndex}
                              >
                                <div className="w-100 mr-2">
                                  <label className="mb-3 ">Deal</label>

                                  {errors.deal && (
                                    <div className="text-danger fs-12">
                                      {errors.deal}
                                    </div>
                                  )}
                                  <div className="d-flex  w-100">
                                    <input
                                      type="text"
                                      disabled={deal.other ? false : true}
                                      className="form-control deal-input"
                                      placeholder={
                                        deal.other
                                          ? "Enter custom deal"
                                          : "Select.."
                                      }
                                      required="required"
                                      value={deal.deal}
                                      onChange={(e) =>
                                        handleTextInputChange(
                                          e,
                                          dayIndex,
                                          dealIndex
                                        )
                                      }
                                    />
                                    <div className="contact-name">
                                      <select
                                        className={"form-control select-deal"}
                                        value={deal.deal}
                                        onChange={(e) =>
                                          handleDealInputChange(
                                            e,
                                            dayIndex,
                                            dealIndex,
                                            "deal"
                                          )
                                        }
                                        required
                                      >
                                        <option hidden>Select..</option>
                                        <option value="Wine">Wine</option>
                                        <option value="Shots">Shots</option>
                                        <option value="Margarita">
                                          Margarita
                                        </option>
                                        <option value="Well Cocktails">
                                          Well Cocktails
                                        </option>
                                        <option value="Beer Pitcher">
                                          Beer Pitcher
                                        </option>
                                        <option value="other">Other</option>
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div className="w-100">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <label className="mb-3 ">Price</label>
                                    {happyHourInfo[dayIndex]?.deals?.length >
                                      1 && (
                                      <button
                                        type="button"
                                        className=" delete-bTn"
                                        onClick={() =>
                                          deleteDeal(dayIndex, dealIndex)
                                        }
                                      >
                                        X
                                      </button>
                                    )}
                                  </div>
                                  <div className="d-flex form-control">
                                    {!deal.type || deal.type !== "2 for 1" ? (
                                      <input
                                        type="number"
                                        required
                                        className="border-0 w-100"
                                        value={deal.price}
                                        onChange={(e) =>
                                          handleDealInputChange(
                                            e,
                                            dayIndex,
                                            dealIndex,
                                            "price"
                                          )
                                        }
                                      />
                                    ) : null}
                                    <select
                                      className="border-0"
                                      value={deal.type}
                                      onChange={(e) =>
                                        handleDealInputChange(
                                          e,
                                          dayIndex,
                                          dealIndex,
                                          "type"
                                        )
                                      }
                                      required
                                    >
                                      <option hidden></option>
                                      <option value="Fixed">$</option>
                                      <option value="value">$ Off</option>
                                      <option value="percentage">% Off</option>
                                      <option value="2 for 1">2 for 1</option>
                                    </select>
                                  </div>

                                  {errors.price && deal.type !== "2 for 1" && (
                                    <div className="text-danger fs-12">
                                      {errors.price}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )
                          )}
                          <h6
                            className="my-4 text-orange"
                            onClick={() => addDeal(dayIndex)}
                            style={{ cursor: "pointer", width: "200px" }}
                          >
                            Add New Item
                          </h6>
                        </div>
                      )}
                    </div>
                  ))}

                  <div className="text-right">
                    <button
                      type="submit"
                      className="btn text-white  mr-3"
                      style={{ backgroundColor: "#F36C03", border: "none" }}
                      // onClick={() => setEventModal(true)}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>
        )}
      </div>
      <AddEvent
        show={eventModal}
        props={props}
        onHide={() => setEventModal(false)}
      />
    </div>
    // )}
    // </>
  );
}

const mapStateToProps = (state) => {
  return {
    userId: state.UserData.userId,
  };
};
export default connect(mapStateToProps)(AddVenderDetails);
